import styled from 'styled-components'

export const Container = styled.div`
  background-color: #00C0DA;
  display: flex;
  overflow: hidden;
  padding: 80px 0;

  @media (max-width: 568px) {
    padding-block: 40px 32px;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-around;
  gap: 16px;
  margin-inline: auto;
  max-width: 1366px;
  padding-inline: 24px;
  width: 100%;

  .carousel {
    max-height: 496px;
    max-width: 592px;
  }

  @media (max-width: 911px) {
    flex-direction: column;
    gap: 32px;

    .carousel {
      .dots {
        bottom: 16px;
      }
    }
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 546px;

  & > h1 {
    color: #FFF;
    font-size: 2rem;
    font-weight: 500;
  }

  & > h6 {
    color: #F6F6FA;
    font-size: 1.125rem;
    font-weight: 600;
  }

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    list-style: none;

    & > li {
      align-items: center;
      color: #F6F6FA;
      display: inline-flex;
      font-size: 1rem;
      gap: 12px;
    }
  }

  @media (max-width: 568px) {
    & > figure {
      align-self: center;
    }

    & > h1 {
      font-size: 1.5rem;
    }

    & > h6 {
      font-size: 1rem;
    }

    & > ul {
      & > li {
        font-size: 0.75rem;
      }
    }
  }
`

export const Slide = styled.figure`
  border-radius: 16px;
  overflow: hidden;
`
